import { Tooltip, Typography } from "@mui/material";
import React from "react";
import { baseColors } from "../../Themes/colors";
import { useEffect, useRef, useState } from "react";
export var TruncatedTooltipText = function (_a) {
    var value = _a.value, color = _a.color;
    var textRef = useRef(null);
    var _b = useState(false), isTruncated = _b[0], setIsTruncated = _b[1];
    useEffect(function () {
        var el = textRef.current;
        if (el) {
            setIsTruncated(el.scrollWidth > el.clientWidth);
        }
    }, [value]);
    return (React.createElement(Tooltip, { title: value, disableHoverListener: !isTruncated },
        React.createElement(Typography, { ref: textRef, variant: "body1", fontWeight: 500, color: baseColors.fullBlack, sx: {
                maxWidth: "100%",
                overflow: "hidden",
                textOverflow: "ellipsis",
                whiteSpace: "nowrap",
                cursor: isTruncated ? "pointer" : "default",
            } }, value || "--")));
};
